import {AddFormV2Type} from 'context/guest';
import {FORM_NAMES} from 'utils/guestForm';
import {groupByGroupName} from './utils/groupByGroupName';
import {FieldGroup} from './FieldGroup/FieldGroup';
import type {FormFieldsMapper} from './types';
import {DefaultField} from './DefaultField';
import {CustomField} from './CustomField';
import {FormFieldV2, FIELD_TYPES, STANDARD_FIELD_V2_TYPES} from '@guestapp/sdk';
import {useGuestGroup} from 'hooks';
import {useTranslation} from 'react-i18next';

const adaptCustomType = (type: STANDARD_FIELD_V2_TYPES): FIELD_TYPES => {
  const types = Object.values(FIELD_TYPES) as string[];
  if (types.includes(type)) {
    return type as unknown as FIELD_TYPES;
  }
  return FIELD_TYPES.text;
};

const adaptCustomField = (field: FormFieldV2) => ({
  field_type: adaptCustomType(field.type),
  is_custom: true,
  is_required: field.is_required,
  name: field.name,
  names: field.name_translations ? [field.name_translations] : [],
  placeholders: field.placeholder_translations ? [field.placeholder_translations] : [],
  configuration: field.configuration,
});

type Props = {
  defaultFieldsMapper: FormFieldsMapper;
  formFields: AddFormV2Type;
  isDisabled?: boolean;
};
export const GroupedFields = ({defaultFieldsMapper, formFields, isDisabled}: Props) => {
  const {t} = useTranslation();
  const {isLeaderGuest} = useGuestGroup();
  const groups = groupByGroupName(formFields, defaultFieldsMapper, isLeaderGuest);

  return groups.map((group, index) => (
    <FieldGroup title={group.title} key={index} withWhyDataRequired={index === 0}>
      {group.fields.map((field, index) =>
        field.is_custom ? (
          <CustomField
            key={index}
            field={adaptCustomField(field)}
            disabled={isDisabled}
            required={field.is_required ? t('this_field_is_required') : false}
          />
        ) : (
          <DefaultField
            key={index}
            formFieldsMapper={defaultFieldsMapper}
            fieldName={field.name as FORM_NAMES}
            formFields={formFields}
          />
        ),
      )}
    </FieldGroup>
  ));
};
